const setSizesByLocale = (allCartPageSizes) => {
  const locale = window.Phill.locale;
  allCartPageSizes.forEach((element) => {
    if (element.dataset.isFootwearSizes === "true") {
      if (locale == "us") {
  element.innerText = element.dataset.footwearUs;
      } else if (locale == "gb") {
  element.innerText = element.dataset.footwearUk;
      }
    }
  });
}

const removeButtons = document.querySelectorAll('.cart__quantity-remove');
const plusButtons = document.querySelectorAll('.cart__quantity-plus');
const minusButtons = document.querySelectorAll('.cart__quantity-minus');

const resetCartPageJS = cartDom => {
  const allCartPageSizes = cartDom.querySelectorAll(".cart__variant-size");
setSizesByLocale(allCartPageSizes);
const newRemoveButtons = cartDom.querySelectorAll('.cart__quantity-remove');
  newRemoveButtons.forEach(button => button.addEventListener('click', e => {
  e.preventDefault()
    handleRemoveButtonClick(button)
  }))
const newAddButtons = cartDom.querySelectorAll('.cart__quantity-plus');
  newAddButtons.forEach(button => button.addEventListener('click', e => {
  e.preventDefault()
    handlePlusButtonClick(button)
  }))
const newMinusButtons = cartDom.querySelectorAll('.cart__quantity-minus');
  newMinusButtons.forEach(button => button.addEventListener('click', e => {
  e.preventDefault()
    handleMinusButtonClick(button)
  }))
}

const replaceCartPageHTML = (cartDom, newCartDom) => {
  cartDom.querySelector('.go-cart-drawer__item-count').innerHTML = newCartDom.querySelector('.go-cart-drawer__item-count').innerHTML
  cartDom.querySelector('tbody').innerHTML = newCartDom.querySelector('tbody').innerHTML
  const newCartSubtotalItems = newCartDom.querySelectorAll('.cart__footer-container > .grid__item > div')
  cartDom.querySelectorAll('.cart__footer-container > .grid__item > div').forEach((div, index) => {
    // Update all the dom elements except for the payment methods, to avoid shifting of content
    if (!div.classList.contains("cart__payment-methods")) {
  div.replaceWith(newCartSubtotalItems[index])
}
  })
}

const handleRemoveButtonClick = (button) => {
  const updateData = {updates: { }, sections: "cart-template"}
  const { variantId, productId, productName, productVendor, productType, productPrice } = button.parentNode.dataset;
  window.Phill.tracking.removeFromCart({ variantId, productId, origin: "cart_page", productName, productVendor, productType, productPrice })
  updateData["updates"][variantId] = 0;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
      },
    body: JSON.stringify(updateData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    const cartDom = document.getElementById('shopify-section-cart-template')
    const newCartDom = new DOMParser().parseFromString(data.sections["cart-template"], 'text/html');
    if (newCartDom.querySelector('.cart__empty')) {
      cartDom.innerHTML = newCartDom.getElementById('shopify-section-cart-template').innerHTML;
    } else {
      replaceCartPageHTML(cartDom, newCartDom)
      resetCartPageJS(cartDom)
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
removeButtons.forEach(button => button.addEventListener('click', e => {
  e.preventDefault()
  handleRemoveButtonClick(button)
}))

const handlePlusButtonClick = (button) => {
  const updateData = {updates: { }, sections: "cart-template"}
  const { variantId, productId, quantity: existingQuantity, productName } = button.parentNode.dataset;
  window.Phill.tracking.changeItemQuantity({ variantId, productId, productName, origin: "cart_drawer", existingQuantity, quantityChange: "+1" });
  updateData["updates"][variantId] = parseInt(existingQuantity, 10) + 1;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updateData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    const cartDom = document.getElementById('shopify-section-cart-template');
    const newCartDom = new DOMParser().parseFromString(data.sections["cart-template"], 'text/html');
    replaceCartPageHTML(cartDom, newCartDom)
    resetCartPageJS(cartDom)
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
const handleMinusButtonClick = (button) => {
  const updateData = {updates: { }, sections: "cart-template"}
  const { variantId, productId, quantity: existingQuantity, productName } = button.parentNode.dataset;
  window.Phill.tracking.changeItemQuantity({ variantId, productId, productName, origin: "cart_drawer", existingQuantity, quantityChange: "-1" });
  updateData["updates"][variantId] = parseInt(existingQuantity, 10) - 1;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updateData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    const cartDom = document.getElementById('shopify-section-cart-template')
    const newCartDom = new DOMParser().parseFromString(data.sections["cart-template"], 'text/html');
    replaceCartPageHTML(cartDom, newCartDom)
    resetCartPageJS(cartDom)
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
plusButtons.forEach(button => button.addEventListener('click', e => {
  e.preventDefault()
  handlePlusButtonClick(button)
}))
minusButtons.forEach(button => button.addEventListener('click', e => {
  e.preventDefault()
  handleMinusButtonClick(button)
}))

const initFootwearSizes = async () => {
  const url = window.location.origin + "/browsing_context_suggestions.json";
const obj = await(await fetch(url)).json();
const locale = obj.detected_values.country.handle.toLowerCase();
window.Phill.locale = locale;
const allCartPageSizes = document.querySelectorAll(".cart__variant-size");
setSizesByLocale(allCartPageSizes);
}
initFootwearSizes();